import { TitleCasePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  CUSTOM_ELEMENTS_SCHEMA,
  inject,
  input,
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { MetadataService } from '../../services/metadata/metadata';
import { QuizService } from '../../services/quiz/quiz';
import { ReaderNavigatorService } from '../../services/readium/navigator/reader-navigator';

@Component({
  selector: 'nr-create-question-actions',
  imports: [TranslatePipe, TitleCasePipe],
  templateUrl: './create-question-actions.html',
  styleUrl: './create-question-actions.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CreateQuestionActionsComponent {
  private readonly quizService = inject(QuizService);
  private readonly metadataService = inject(MetadataService);
  private readonly readerNavigatorService = inject(ReaderNavigatorService);

  private readonly selectedText = computed<string | undefined>(
    () => this.readerNavigatorService.currentSelectionContext()?.selectedText,
  );

  readonly menuFor = input.required<string>();

  readonly canUseAi = this.metadataService.canUseAi;

  // With text selected, the material is tied to a highlight of it, as from the selection popover.
  async addQuestion(ai: boolean): Promise<void> {
    if (ai && !this.canUseAi()) return;
    await this.quizService.startCreateQuizFromSelection(ai, this.selectedText(), 'question');
  }

  async addQuiz(ai: boolean): Promise<void> {
    if (ai && !this.canUseAi()) return;
    await this.quizService.startCreateQuizFromSelection(ai, this.selectedText());
  }

  async addNote(): Promise<void> {
    await this.quizService.startCreateQuizFromSelection(false, this.selectedText(), 'note');
  }
}
